// @ts-nocheck
import { makeAutoObservable } from 'mobx'
// import getData from '../../api/getData'
import baseDataHandler from './utils/baseDataHandler copy'
import {
  IDependencies,
  IStepSetting,
  IValues,
} from '../../interface/steps.interface'
import { IInputStatus, IStepStatus } from '../../interface/progress.interface'
import runActions from './utils/api/runActions'
import {
  tooltipHandler,
} from './utils/tooltip/tooltipHandler'
import getCookieParam from '../../lib/utils/getCookieParam';

interface BaseProps {
  stepsStoreConfig: any
  stepsStoreApi: any
}

class StepsStore {
  rootStore: any
  stepsStoreConfig: any
  stepsStoreApi: any
  values: IValues
  inputsData: any
  stepsSetting: IStepSetting[] = []
  stepsInputs: string[][] = []
  dependencies: IDependencies
  dependenciesForCuurentStep: IDependencies
  currentStep: number = 0
  apiErrors: any
  isLoading: boolean = false
  isApiLoading: boolean = false
  timers: any = []
  firstErrorName: string | null = null
  inputLayout: string[] = []
  replacements: {} = {}
  isTooltip = true
  tooltipStepNumber = 2
  isOptions: string[] = []

  lff_uid: string | null = null
  utm = null

  // for b.creditsfast
  invalidInputs: Record<string, string> = {}
  stepsPixel: string = ''
  showSpinner: boolean = false
  needsToScroll: boolean = false

  isIbanCheckbox: boolean = true

  validsAsync = {}


  constructor(rootStore: any) {
    this.rootStore = rootStore
    this.values = {}
    makeAutoObservable(this)
  }

  setConfigs({
    stepsStoreConfig,
    stepsStoreApi
  }: BaseProps) {
    this.stepsStoreConfig = stepsStoreConfig
    this.stepsStoreApi = stepsStoreApi
    this.baseData()
  }

  async baseData() {
    try {
      //document.cookie = 'lff_uid=a74fde8449e6d98871a45e7f88764ad9'
      let token = localStorage.getItem('newToken') || getCookieParam('token')
      console.log('token', token)
      document.cookie = `token=${token}; expires=Thu, 01 Jan 2099 00:00:00 UTC;`
      const localLffUid = localStorage.getItem('lff_uid')
      
      const { stepsSettings, lff_uid, ...data } = await this.stepsStoreConfig.getData({
        getUser: this.stepsStoreApi.getUser,
        token
      }) 

      if (lff_uid || localLffUid) {
        this.lff_uid = lff_uid || localLffUid
        localStorage.setItem('lff_uid', this.lff_uid)
      }
      console.log(stepsSettings)
      console.log(data)
      // const req = await getData(this.lff_uid)
      //@ts-ignore
      // const data = req.data

      const { 
        newValues, 
        inputsData, 
        steps, 
        dependencies, 
        dependenciesForCuurentStep,
        isFullSteps,
        currentStepNumber 
      } =
        baseDataHandler(data)
      this.rootStore.ProgressStore.baseStepsProgress(
        steps,
        stepsSettings.settings,
        inputsData,
        //@ts-ignore
        newValues || {},
        currentStepNumber,
        stepsSettings.isOptions
      )
      console.log(steps)
      // console.log(newValues)
      if (!data?.values) {
        console.log('removeItem lff_uid')
        localStorage.removeItem('lff_uid')
        this.lff_uid = null
      }

      this.currentStep = currentStepNumber
      this.values = newValues

      this.inputsData = inputsData

      this.stepsSetting = stepsSettings.settings as IStepSetting[]

      this.stepsInputs = steps

      this.dependencies = dependencies
      this.dependenciesForCuurentStep = dependenciesForCuurentStep
      this.isLoading = true
      console.log('isLoading')

      this.inputLayout = stepsSettings.desktopInputLayout
      this.replacements = stepsSettings.replacements
      this.isOptions = stepsSettings.isOptions
      this.stepsPixel = stepsSettings.pixel

      if (this.stepsStoreConfig?.start){
        this.stepsStoreConfig.start({step: this.currentStep})
      }

      if (isFullSteps) {
        console.log('-----> isFullSteps')
        this.redirectButtonHandler()
      }
    } catch (error) {
      console.log(error)
    }

  }

  changeIbanCheckbox = () => {
    this.isIbanCheckbox = !this.isIbanCheckbox
  }

  setNeedsToScroll = (needsToScroll) => {
    this.needsToScroll = needsToScroll
  }

  changeValues = async (name: string, newValue: string) => {
    try {
      console.log('changeValues', name, newValue)
      this.rootStore.ChangeInputValue.changeValues(name, newValue)
    } catch (error) {
      console.log(error)
    }
  }

  checkChangeValue = (name: string, newValue: string) => {
    const status = this.rootStore.ProgressStore.stepsProgress[this.currentStep].inputs[name].status
    this.rootStore.ProgressStore.changeStatus(name, IInputStatus.none, this.currentStep)
    if (status !== IInputStatus.none) {
      this.rootStore.ProgressBar.checkProgress()
    }
  }

  prevCurrentStep = () => {
    console.log('prevCurrentStep')
    try {
      if (this.currentStep > 0) {
        this.rootStore.ProgressStore.changeStepStatus(
          this.currentStep,
          IStepStatus.change
        )
        this.currentStep = this.currentStep - 1
        if (this.stepsStoreConfig?.prevCurrentStep) {
          this.stepsStoreConfig?.prevCurrentStep({step: this.currentStep})
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  nextCurrentStep = async () => {
    try {
      this.rootStore.NextStep.nextCurrentStep()
      console.log({...this.invalidInputs})
    } catch (error) {
      console.log(error)
    }

  }

  changeCurrentStep = (newStepNumber: number) => {
    try {
      console.log('changeCurrentStep')
      if (newStepNumber < this.currentStep) {
        this.rootStore.ProgressStore.changeAllStepsStatus(
          newStepNumber,
          this.currentStep
        )
        this.currentStep = newStepNumber

        if (this.stepsStoreConfig?.changeCurrentStep) {
          this.stepsStoreConfig?.changeCurrentStep({step: this.currentStep})
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Добавить Lottie spinner

  redirectButtonHandler = async () => {
    try {
      this.rootStore.RedirectButton.redirectButtonHandler()
    } catch (error) {
      console.log(error)
    }
    // try {
    //   const [result, firstErrorName] =
    //     this.rootStore.ProgressStore.nextStepStatus(this.currentStep)
    //   console.log('result--->', result)
    //   this.firstErrorName = firstErrorName
    //   if (result) {
    //     const actions = this.stepsSetting[this.currentStep].actions || null
    //     if (actions) {
    //       this.isApiLoading = true
    //       const data = await runActions(
    //         this.stepsStoreApi,
    //         actions,
    //         this.values,
    //         this.stepsInputs[this.currentStep],
    //         this.lff_uid
    //       )
    //       //const data = await runActions(actions, this.values)
    //       console.log('data.status--->', data)
    //       if (data.status) {
    //         this.showSpinner = true

    //         this.handleRedirect()
    //       } else {

    //         this.apiErrors = {
    //           ...this.apiErrors,
    //           ...data.errors,
    //         }
    //         if (data.error) {
    //           this.apiErrors.error = data.error
    //         }
    //       }
    //       this.isApiLoading = false
    //     } else {
    //       this.handleRedirect()
    //     }
    //   }
    //   //this.showSpinner = false
    // } catch (error) { 
    //  console.log(error)
    // }
  }

  // handleRedirect = () => {
  //   console.log('redirect')
  //   this.stepsStoreConfig.finish(this.lff_uid)
  // }

 

  toolTipEmptyHandler = () => {
    try {
      console.log('toolTipEmptyHandler')
      tooltipHandler(this)
      console.log(this.values['geo_zip'])
    } catch (error) {
      console.log(error)
    }
  }
}

export default StepsStore
